// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"efffd375","334":"06774388","453":"88ed8c78","458":"e39d524e","591":"8d898af4","618":"ecb78940","764":"3ffbc1ef","821":"caabda85","834":"e8a231d8","943":"df29b3a5"}[chunkId] + ".chunk.js";
};